import cn from 'classnames';
import React from 'react';
import IconFullStar from '../../../components/icon/IconFullStar';
import IconHalfStar from '../../../components/icon/IconHalfStar';
import IconEmptyStar from '../../../components/icon/IconEmptyStar';

interface RatingBarProps {
  rating: number
  className?: string
}

export default function RatingBar({rating, className}: RatingBarProps) {
  return (
    <div className={cn('flex flex-row text-yellow', className)}>
      <StarSlot value={2} rating={rating}/>
      <StarSlot value={4} rating={rating}/>
      <StarSlot value={6} rating={rating}/>
      <StarSlot value={8} rating={rating}/>
      <StarSlot value={10} rating={rating}/>
    </div>
  );
}

type RatingSlotProps = {
  value: number
  rating: number
}

function StarSlot({
  value, rating,
}: RatingSlotProps) {
  const star = () => {
    if (value <= rating) {
      return <IconFullStar/>;
    } else if (value === rating + 1) {
      return <IconHalfStar/>;
    }
    return <IconEmptyStar/>;
  };

  return (
    <div className="pr-1">
      {star()}
    </div>
  );
}
